import React from 'react';

import CN from './AnimatedCircle.module.scss';

const AnimatedCircle = ({ children }) => (
  <div className={CN.circleContainer}>
    {children}
    <div className={CN.dotsContainer}>
      {Array.from({ length: 30 }).map((_, index) => (
        <div key={index} className={CN.dot} style={{ animationDelay: `${index * 0.1}s` }}></div>
      ))}
    </div>
  </div>
);

export default AnimatedCircle;
